import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


import Most_View_Ar from './Most_View_Ar.js';

 
  
 

export default function Tennis_Ar() {
    const jsonbasket = variables.basename_url +'updates/index/Athlethixnet_HomeAr_Tennis.json';
 
    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
 
    
    async function refda() {  
       
        //  To Show or Hidden Header And Footer
      document.getElementById('Arabic_Header').hidden = false;
      document.getElementById('Arabic_Footer').hidden = false;
      //

//
document.getElementById('Main_Dir').dir = "rtl";
  
//


      setNisLoading(true);


      Get_Data_Tennis_Ar()
  
    };
   
    useEffect(() => {
      
       
        setNisLoading(true);
   
        refda();
           },[] )

   

 
           
           const [JsonArray, setJsonArray] = React.useState([]);
           async function Get_Data_Tennis_Ar(){
         
            JsonArray.splice(0);  //to clear All data in your page
        
           setNisLoading(true);
        
           axios.get(jsonbasket)  
        
                 .then(function (response) {
                 setNisLoading( false);
        
                   console.log(response.data);
               
                  
             
        
                 for (let i = 0; i <=5 && i < response.data.length; i++) {
                 
                    JsonArray.push({
                
                    news_title: response.data[i].news_title,
                    news_date:response.data[i].news_date.split(" ")[0],
                     news_imagename:response.data[i].Image  ,
                    link:response.data[i].link,
                    Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,
                    Category:response.data[i].Category,
                  
                  })
                  }
            })      
           }
             
 
         
             
 
     
            return (
          <>
 
 <div className='backgroundcolor'> 
 


 <section className="all-post-style-2-area">
        <div className="container custom-container">
             



      
          <div className="row">
    
    
            <div className="col-lg-8 ">
       <br></br>
            
           
              <div className="bussiness-box mt-3">
              <div className="  titlepadding">
        <div className="about-author-content mt-1">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
          
        <h3 className="breadcrumb-item"><a href="Arabic">الرئيسيه</a></h3>
              <h3 className="breadcrumb-item"><a href="Tennis_Ar">   تنس</a></h3>
         
               
            </ol>
          </nav>
        </div>
      </div>
                <div className="section-title">
               
                </div>

                {JsonArray.map(da=>     
  
  <div key= {da.news_title}  > 
 
                <div className="bussiness-items">
                  <div className="bussiness-post-item">
                    <div className="bussiness-post-thumb">
                      <a href={da.link}>
                      <img className='rounded' style={{ maxWidth: '350px',maxHeight:'190px'}}     src={da.news_imagename} alt="business" />
                      </a>
                    </div>
                    <div className="bussiness-post-content">
                      <h3 className="title1"><a href={da.link}> {da.news_title}</a></h3>
                      <div className="meta-date-link">
                        <span>{new Date(da.news_date).toLocaleDateString('ar-EG')}</span>
                      
                      </div>
                      <p>{da.Description}</p>
             
                    </div>
                  </div>
              
             
               
                 
                
                </div>
                </div>
  )}
 
              </div>
              <br></br>
   <br></br>    
   <br></br>
   <br></br>
            </div>
            <div className="col-lg-4  ">
              <div className="all-post-sidebar-style-2  ">
            {/* most view */}
            <Most_View_Ar/>
                <div className="ad mt-40">
                  <a href="#"><img src="./images/ad/ad-3.png" alt="" /></a>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
         </>
        );
    }


  
